import { render, staticRenderFns } from "./ContestGroups.vue?vue&type=template&id=addc2c42&"
import script from "./ContestGroups.vue?vue&type=script&lang=js&"
export * from "./ContestGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports